/** One end of a journey: a point plus something to show the user. */
export interface PlannerEndpoint {
  lat: number
  lng: number
  label: string
}

/**
 * Everything about a planned journey worth surviving a back navigation: the two
 * endpoints, plus the pair the user actually searched for.
 *
 * `searched` is a separate pair rather than a boolean because choosing an endpoint
 * must not re-run the query — the planner is only asked once the user says so.
 */
export interface PlannedTrip {
  start?: PlannerEndpoint
  end?: PlannerEndpoint
  searched?: { start: PlannerEndpoint; end: PlannerEndpoint }
}

/**
 * Label for a point with no name.
 *
 * The reference app reverse-geocodes dropped pins via the `Geo2Address` command.
 * That endpoint was probed live and **never responds** — every plausible request
 * shape (lat/lng, lng/lat, with and without a trailing flag) times out after 20
 * seconds while the connection is accepted. So a dropped pin shows its
 * coordinates. Unhelpful, but honest, and it keeps arbitrary destinations usable.
 */
export function coordinateLabel(lat: number, lng: number) {
  return `${lat.toFixed(5)}, ${lng.toFixed(5)}`
}
